module.exports = __webpack_public_path__ + "img/Microsoft_SqlServer.f52e8cec.png";